import script from "./AuthButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthButton.vue?vue&type=script&setup=true&lang=js"

import "./AuthButton.vue?vue&type=style&index=0&id=2c0531ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0531ca"]])

export default __exports__